var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHooliHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 564.814,
    height: 323.268,
    viewBox: "0 0 564.814 323.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_11",
    "data-name": "Fill 11",
    d: "M161.671,323.268c-24.327,0-47.095-4.425-67.671-13.153a149.462,149.462,0,0,1-50.862-35.367,155.524,155.524,0,0,1-32.013-51.441A171.513,171.513,0,0,1,0,161.931c0-43.576,15.4-83.905,43.357-113.56a149.49,149.49,0,0,1,50.89-35.292C114.769,4.4,137.454,0,161.671,0S208.536,4.4,229,13.079a148.5,148.5,0,0,1,50.686,35.292c27.769,29.609,43.063,69.939,43.063,113.56a172.686,172.686,0,0,1-11.031,61.375,155.3,155.3,0,0,1-31.809,51.441,148.459,148.459,0,0,1-50.658,35.367C208.732,318.843,185.995,323.268,161.671,323.268Zm0-255.4c-45.917,0-80.544,40.438-80.544,94.062,0,53.284,34.626,93.465,80.544,93.465s80.544-40.438,80.544-94.062C242.215,108.05,207.589,67.869,161.671,67.869Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_16",
    "data-name": "Fill 16",
    d: "M161.671,323.268c-24.327,0-47.095-4.425-67.671-13.153a149.462,149.462,0,0,1-50.862-35.367,155.524,155.524,0,0,1-32.013-51.441A171.513,171.513,0,0,1,0,161.931c0-43.576,15.4-83.905,43.357-113.56a149.491,149.491,0,0,1,50.89-35.292C114.769,4.4,137.454,0,161.671,0S208.537,4.4,229,13.079a148.5,148.5,0,0,1,50.687,35.292c27.77,29.609,43.063,69.939,43.063,113.56a172.685,172.685,0,0,1-11.031,61.375,155.3,155.3,0,0,1-31.809,51.441,148.46,148.46,0,0,1-50.659,35.367C208.733,318.843,186,323.268,161.671,323.268Zm0-255.4c-45.914,0-80.537,40.438-80.537,94.062,0,53.284,34.624,93.465,80.537,93.465s80.544-40.438,80.544-94.062C242.215,108.05,207.589,67.869,161.671,67.869Z",
    transform: "translate(242.062)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHooliHeader);
export default __webpack_public_path__ + "static/media/logo-hooli-header.0df65459b52260521563da4fe139bdc4.svg";
export { ForwardRef as ReactComponent };